<template>
  <div>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-container class="mb-5">
        <v-row>
          <v-col cols="12">
            <p class="headline mb-0">Choose cells required of battery</p>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="size"
              label="Cells Number *"
              required
              outlined
              hide-details
              dense
              type="tel"
              :rules="[rules.required]"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-select
              :items="warranties"
              label="Warranty"
              outlined
              v-model="warranty"
              hide-details
              dense
              :rules="[rules.required]"
            ></v-select>
          </v-col>
          <!-- <v-col cols="12" md="3">
            <v-select
              v-model="location"
              label="Select Location"
              :items="locations"
              outlined
              hide-details
              dense
            ></v-select>
          </v-col> -->
          <v-col cols="12" md="3" v-if="warrantyRange && warrantyRange.grades">
            <v-select
              :items="warrantyRange.gradeList"
              label="Grade"
              outlined
              v-model="selectedGrade"
              hide-details
              dense
              :rules="[rules.required]"
              multiple
            ></v-select>
          </v-col>
          <v-col
            cols="12"
            md="3"
            v-if="warrantyRange && warrantyRange.type === 'input'"
          >
            <v-row>
              <v-col cols="12" md="6" style="padding-top: 0">
                <v-text-field
                  v-model="customRange.min"
                  label="Min"
                  required
                  outlined
                  hide-details
                  dense
                  type="tel"
                  :rules="[rules.required]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" style="padding-top: 0">
                <v-text-field
                  v-model="customRange.max"
                  label="Max"
                  required
                  outlined
                  hide-details
                  dense
                  type="tel"
                  :rules="[rules.required]"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="3">
            <v-btn color="primary" class="mr-4" rounded @click="getCells()">
              Start Battery Creation
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import { balancedcells } from "@/api";
import ranges from "./extendedRanges.json";

export default {
  name: "BatchBalanceForm",
  props: ["warranties", "updateBalancedCells"],

  data: () => ({
    valid: true,
    size: "",
    // location: "Fairfield",
    warranty: "1year",
    loading: false,
    selectedGrade: "",
    rules: {
      required: (v) => !!v || "Name is required",
    },
    balancedCellSummary: [],
    customRange: {
      min: "",
      max: "",
    },
    // locations: ["Fairfield", "LA"],
  }),
  computed: {
    warrantyRange() {
      return ranges[this.warranty];
    },
  },
  methods: {
    getWarrantyRange(warrantyRange, selectedGrades) {
      let range = warrantyRange;
      if (warrantyRange?.grades) {
        let ranges = [];
        selectedGrades.forEach((grade) => {
          const g = warrantyRange.grades[grade];
          ranges.push(g.min, g.max);
        });

        range = {
          min: Math.min(...ranges),
          max: Math.max(...ranges),
        };
      }

      if (warrantyRange?.type === "input") {
        range = {
          min: parseFloat(this.customRange.min) - 0.01,
          max: parseFloat(this.customRange.max),
        };
      }

      return [range.min, range.max];
    },
    async getCells() {
      if (this.$refs.form.validate()) {
        try {
          const warrantyRange = this.getWarrantyRange(
            this.warrantyRange,
            this.selectedGrade
          );
          const { data } = await balancedcells.balancedCellsForBattery(
            this.size,
            warrantyRange
            // this.location
          );
          if (data.cells.length < this.size) {
            this.$toast.error(
              `Can't create battery, only ${data.cells.length} cells available`
            );
          } else {
            this.updateBalancedCells(data.cells, data.batteryNumber, {
              size: this.size,
              range: warrantyRange,
            });
            this.$toast.success("Cells balanced successfully");
          }
        } catch (error) {
          this.$toast.error("Cells balancing failed");
        }
      }
    },
  },
};
</script>